// Shared live/upcoming auction lot helpers (hidden product map + API enrich).
(function () {
  function apiBase() {
    return (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '')
      .replace(/\/+$/, '');
  }

  function apiHeaders() {
    return window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };
  }

  function spriteUrl() {
    if (window.staThemeAssets && window.staThemeAssets.sprite) return window.staThemeAssets.sprite;
    var use = document.querySelector('use[xlink\\:href*="sprite.svg"], use[href*="sprite.svg"]');
    if (use) {
      var ref = use.getAttribute('xlink:href') || use.getAttribute('href') || '';
      return ref.split('#')[0] || '/cdn/shop/t/3/assets/sprite.svg';
    }
    return '/cdn/shop/t/3/assets/sprite.svg';
  }

  function setMoneyPrice(el, dollars) {
    if (!el) return;
    if (window.staSetMoneyEl) window.staSetMoneyEl(el, dollars);
    else if (window.staFormatMoney) el.innerHTML = window.staFormatMoney(dollars);
  }

  function rowAttrs(row) {
    return row && row.attributes ? row.attributes : row || {};
  }

  function attrsFromShowPayload(payload) {
    if (!payload) return null;
    var data = payload.data && !Array.isArray(payload.data) ? payload.data : payload;
    if (!data) return null;
    var attrs = data.attributes || data;
    return {
      row: { id: data.id, attributes: attrs },
      attrs: attrs,
    };
  }

  function normalizeUrlWithAuctionId(url, auctionId) {
    if (!url || url === '#') return '#';
    var isAbs = /^https?:\/\//i.test(url);
    var isProductsPath = /^\/?products\//i.test(url);
    if (!isAbs) {
      url = isProductsPath
        ? (url.startsWith('/') ? url : '/' + url)
        : '/products/' + url.replace(/^\/+/, '');
      url = new URL(url, window.location.origin).href;
    }
    try {
      var u = new URL(url);
      if (auctionId != null && String(auctionId).trim() !== '') {
        u.searchParams.set('auction_id', String(auctionId));
      }
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  // Card date + exact time, e.g. "7/24/2026 at 2:00 P.M EDT" (visitor
  // locale/timezone, timezone label from sta-time.js).
  function fmtDateTime(d) {
    if (window.staFormatDateTime) return window.staFormatDateTime(d, 'short');
    try {
      return d.toLocaleString();
    } catch (e) {
      return '';
    }
  }

  function startCountdown(el, iso, labelWhenDone) {
    var p = el.querySelector('p') || el.appendChild(document.createElement('p'));
    function render() {
      var ts = Date.parse(iso || '');
      if (!isFinite(ts)) {
        p.textContent = '';
        return;
      }
      var s = Math.max(0, Math.floor((ts - Date.now()) / 1000));
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      var sec = s % 60;
      p.textContent =
        d + h + m + sec <= 0
          ? labelWhenDone || 'Ended'
          : d + 'd ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(sec).padStart(2, '0') + 's';
    }
    render();
    var t = setInterval(render, 1000);
    var mo = new MutationObserver(function () {
      if (!document.body.contains(el)) {
        clearInterval(t);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /** 24h ended-lot hold, in seconds — shared with the catalogue grids. */
  function holdSec() {
    var ms = window.staEndedLotHoldMs || 24 * 60 * 60 * 1000;
    return Math.floor(ms / 1000);
  }

  function collectShopifyAuctionLots() {
    var nowSec = Math.floor(Date.now() / 1000);
    var holdCutoff = nowSec - holdSec();
    var lots = [];

    document.querySelectorAll('ul.urls-check-cards-products li[data-product-id]').forEach(function (li) {
      var startTs = parseInt(li.getAttribute('data-auction-start-ts') || '0', 10) || 0;
      var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '0', 10) || 0;
      if (!startTs || !endTs) return;
      // A finished lot keeps its place for 24h showing its result; after that it is
      // gone from here, as is a Buy Now lot that never was part of this hold.
      if (endTs <= holdCutoff) return;
      var isBuyNow = li.getAttribute('data-buy-now') === 'true';
      if (isBuyNow && endTs > nowSec) return;

      var handles = String(li.getAttribute('data-collection-handles-of-products') || '').trim();
      if (!handles) return;

      lots.push({
        productId: String(li.getAttribute('data-product-id') || '').trim(),
        href: String(li.getAttribute('data-href') || '').trim(),
        startTs: startTs,
        endTs: endTs,
        auctionApiId: String(li.getAttribute('data-auction-api-id') || '').trim(),
        title: String(li.getAttribute('data-product-title') || '').trim(),
        sku: String(li.getAttribute('data-product-sku') || '').trim(),
        image: String(li.getAttribute('data-product-image') || '').trim(),
        priceCents: parseInt(li.getAttribute('data-store-price-cents') || '0', 10) || 0,
        buyNow: isBuyNow,
        lotSold: li.getAttribute('data-lot-sold') === 'true',
      });
    });

    return lots;
  }

  function partitionLots(lots, nowSec) {
    var live = [];
    var upcoming = [];
    var ended = [];
    lots.forEach(function (lot) {
      if (lot.startTs <= nowSec && nowSec < lot.endTs) live.push(lot);
      else if (nowSec < lot.startTs && nowSec < lot.endTs) upcoming.push(lot);
      else if (lot.endTs <= nowSec) ended.push(lot);
    });
    live.sort(function (a, b) {
      return a.endTs - b.endTs;
    });
    upcoming.sort(function (a, b) {
      return a.startTs - b.startTs;
    });
    // Most recently ended first: the freshest result leads the held lots.
    ended.sort(function (a, b) {
      return b.endTs - a.endTs;
    });
    return { live: live, upcoming: upcoming, ended: ended };
  }

  function lotToFallbackRow(lot) {
    var startIso = new Date(lot.startTs * 1000).toISOString();
    var endIso = new Date(lot.endTs * 1000).toISOString();
    var price = lot.priceCents > 0 ? lot.priceCents / 100 : 0;
    var productUrl = lot.href
      ? new URL(lot.href.startsWith('/') ? lot.href : '/' + lot.href, window.location.origin).href
      : '#';
    return {
      id: lot.auctionApiId || null,
      attributes: {
        product_name: lot.title || 'Auction Item',
        product_sku: lot.sku,
        product_image_url: lot.image,
        product_url: productUrl,
        start_date: startIso,
        end_date: endIso,
        current_price: price,
        initial_price: price,
        bids_count: 0,
      },
    };
  }

  function fetchAuctionById(auctionId) {
    var API_BASE = apiBase();
    var headers = apiHeaders();
    if (!auctionId || !API_BASE) return Promise.resolve(null);
    var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
    var path = window.staAuctionShowPath
      ? window.staAuctionShowPath(auctionId, customerId)
      : '/api/auctions/' + encodeURIComponent(String(auctionId));
    return fetch(API_BASE + path, { headers: headers, mode: 'cors' })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchAuctionByProductId(productId) {
    var API_BASE = apiBase();
    var headers = apiHeaders();
    if (!productId || !API_BASE) return Promise.resolve(null);
    var fetchFn = window.staFetchAuctionsByProductIds
      ? window.staFetchAuctionsByProductIds([productId], { perPage: 1 })
      : fetch(API_BASE + '/api/auctions?product_ids=' + encodeURIComponent(String(productId)), {
          headers: headers,
          mode: 'cors',
        }).then(function (r) {
          if (!r.ok) return null;
          return r.json();
        });
    return fetchFn
      .then(function (payload) {
        if (!payload) return null;
        var rows = window.staPickAuctionArray ? window.staPickAuctionArray(payload) : payload.data || [];
        if (!rows.length) return null;
        return attrsFromShowPayload({ data: rows[0] });
      })
      .catch(function () {
        return null;
      });
  }

  function enrichLot(lot) {
    if (lot.auctionApiId) {
      return fetchAuctionById(lot.auctionApiId).then(function (payload) {
        var parsed = attrsFromShowPayload(payload);
        if (parsed && parsed.row) return parsed.row;
        return lotToFallbackRow(lot);
      });
    }
    if (lot.productId) {
      return fetchAuctionByProductId(lot.productId).then(function (parsed) {
        if (parsed && parsed.row) return parsed.row;
        return lotToFallbackRow(lot);
      });
    }
    return Promise.resolve(lotToFallbackRow(lot));
  }

  function buildCardShell() {
    var sprite = spriteUrl();
    var html =
      '<div class="sta-product-card">' +
      '<div class="sta-product-card__header">' +
      '<a href="#" class="sta-product-card__ill"><img src="" alt="" class="sta-product-card__img" loading="lazy"></a>' +
      '<span class="sta-product-card__badge sta-product-badge" style="display:none;"><span class="sta-product-badge__name"></span></span>' +
      '<button class="sta-product-card__to-wish sta-wish-btn" title="Add to wishlist" aria-label="Add to wishlist"></button>' +
      '</div>' +
      '<div class="sta-product-card__body">' +
      '<h3 class="sta-product-card__title"><a href="#">Auction Item</a></h3>' +
      '<div class="sta-product-card__auction"><span data-auction-label>Auction</span></div>' +
      '</div>' +
      '<div class="sta-product-card__info"><div class="sta-product-card__info-row sta-product-card__info-row--no-estimate">' +
      '<div class="sta-product-specs">' +
      '<div class="sta-product-spec"><span class="sta-product-spec__ico"></span><div class="sta-product-spec__body"><div class="sta-product-spec__title">SKU: —</div></div></div>' +
      '<div class="sta-product-spec">' +
      '<svg class="svg-ico sta-product-spec__ico"><use xlink:href="' +
      sprite +
      '#stopwatch"></use></svg>' +
      '<div class="sta-product-spec__body"><div class="sta-product-spec__title">—</div><p></p></div>' +
      '</div></div>' +
      '<div class="sta-product-card__estimate-slot" data-price-estimate-slot hidden></div></div></div>' +
      '<div class="sta-product-card__footer">' +
      '<div class="sta-product-card__price">' +
      '<div class="sta-product-spec__body sta-product-price"><div class="sta-product-price__title">—</div><div class="sta-product-price__price"><small>$</small>0<span class="sta-money__code"> CAD</span></div></div>' +
      '<div class="sta-product-card__bids">' +
      '<svg class="svg-ico sta-product-card__bids-ico"><use xlink:href="' +
      sprite +
      '#auction-hammer"></use></svg>' +
      '<div class="sta-product-card__bids-body"><div class="sta-product-card__bids-count">0</div><div>Bids</div></div>' +
      '</div></div>' +
      '<a href="#" class="sta-btn _secondary _full center">—</a>' +
      '</div></div>';
    var t = document.createElement('div');
    t.innerHTML = html.trim();
    return t.firstElementChild;
  }

  function fillLiveAuctionCard(row, mode, lotFallback) {
    var a = rowAttrs(row);
    var card = buildCardShell();
    var name = a.auction_name || a.product_name || a.name || (lotFallback && lotFallback.title) || 'Auction Item';
    var sku = a.product_sku || (lotFallback && lotFallback.sku) || '';
    var img = a.product_image_url || (lotFallback && lotFallback.image) || '';
    var url = a.product_url || (lotFallback && lotFallback.href) || '#';
    var aid = (row && row.id) || a.auction_id || a.id || (lotFallback && lotFallback.auctionApiId) || null;
    var startIso = a.start_date || a.start_at || null;
    var endIso = a.end_date || a.end_at || null;
    if (!startIso && lotFallback) startIso = new Date(lotFallback.startTs * 1000).toISOString();
    if (!endIso && lotFallback) endIso = new Date(lotFallback.endTs * 1000).toISOString();
    var storeDollars =
      lotFallback && lotFallback.priceCents > 0 ? lotFallback.priceCents / 100 : null;
    var price = window.staAuctionDisplayPrice
      ? window.staAuctionDisplayPrice(a, storeDollars)
      : storeDollars;
    var bids = a.bid_count || a.bids_count || 0;
    url = normalizeUrlWithAuctionId(url, aid);

    var link = card.querySelector('.sta-product-card__ill');
    if (link) link.href = url;
    var imgEl = card.querySelector('.sta-product-card__img');
    if (imgEl) {
      if (img) {
        imgEl.src = img;
        imgEl.alt = name;
        imgEl.removeAttribute('srcset');
      } else {
        imgEl.removeAttribute('src');
      }
    }

    var titleA = card.querySelector('.sta-product-card__title a');
    if (titleA) {
      titleA.textContent = name;
      titleA.href = url;
    }
    var pill = card.querySelector('.sta-product-card__auction [data-auction-label]');
    var skuTitle = card.querySelector('.sta-product-spec__title');
    if (skuTitle) skuTitle.textContent = sku ? 'SKU: ' + sku : 'SKU: —';

    var badge = card.querySelector('.sta-product-card__badge');
    var timingBody = card.querySelectorAll('.sta-product-spec__body')[1] || card.querySelector('.sta-product-spec__body');
    var timingTitle = timingBody ? timingBody.querySelector('.sta-product-spec__title') : null;
    var priceTitle = card.querySelector('.sta-product-price__title');
    var priceEl = card.querySelector('.sta-product-price__price');
    var bidsEl = card.querySelector('.sta-product-card__bids-count');
    var cta = card.querySelector('.sta-btn._secondary') || card.querySelector('.sta-btn');

    if (mode === 'ended') {
      // Inside the 24h hold: display only, never biddable. Sold reads its hammer
      // price; a lot rolled over to Buy Now reads its Buy Now price and button.
      // Same wording as the catalogue cards in live-auctions.js.
      var hasWinner = !!(window.staHasAuctionWinner && window.staHasAuctionWinner(a));
      var isSold = hasWinner || !!(lotFallback && lotFallback.lotSold);
      var isBuyNowLot = !isSold && !!(lotFallback && lotFallback.buyNow) && storeDollars != null;

      if (badge) {
        badge.classList.remove('_live', '_upcoming');
        if (isSold) {
          badge.style.display = '';
          badge.classList.add('_sold');
          badge.querySelector('.sta-product-badge__name').textContent = 'Sold';
        } else {
          // Nobody won it, so no Sold badge — matches past-auctions.js.
          badge.style.display = 'none';
        }
      }
      if (pill) pill.textContent = 'Past Auction';
      if (timingTitle) timingTitle.textContent = isBuyNowLot ? 'Buy now' : 'Ended';
      if (timingBody) {
        var timingP = timingBody.querySelector('p');
        if (timingP) timingP.textContent = '';
      }
      if (priceTitle) {
        priceTitle.textContent = isSold
          ? 'Hammer price:'
          : isBuyNowLot
            ? 'Buy now price:'
            : 'Latest bid:';
      }
      if (priceEl) {
        var endedPrice = isBuyNowLot ? storeDollars : price;
        if (endedPrice != null) setMoneyPrice(priceEl, endedPrice);
        else priceEl.innerHTML = '';
      }
      if (bidsEl) bidsEl.textContent = bids;
      if (cta) {
        cta.href = url;
        cta.textContent = isBuyNowLot ? 'Buy Now' : 'Lot Details';
        // Red is for live lots; ended ones take the plain blue button.
        cta.classList.remove('_secondary');
      }
    } else if (mode === 'live') {
      if (badge) {
        badge.style.display = '';
        badge.classList.add('_live');
        badge.classList.remove('_upcoming');
        badge.querySelector('.sta-product-badge__name').textContent = 'Live';
      }
      if (pill) pill.textContent = 'Live Auction';
      if (timingTitle && endIso) {
        timingTitle.textContent = 'Ends ' + fmtDateTime(new Date(endIso));
      }
      if (timingBody && endIso) startCountdown(timingBody, endIso, 'Ended');
      if (priceTitle) {
        priceTitle.textContent = window.staAuctionLivePriceLabel
          ? window.staAuctionLivePriceLabel(bids)
          : 'Current bid:';
      }
      if (priceEl && price != null) setMoneyPrice(priceEl, price);
      if (bidsEl) bidsEl.textContent = bids;
      if (cta) {
        cta.href = url;
        cta.textContent = 'Place Bid';
        cta.classList.add('_secondary');
      }
    } else {
      if (badge) {
        badge.style.display = '';
        badge.classList.remove('_live');
        // "Upcoming" is too long for the badge circle — _upcoming scales the type down to fit.
        badge.classList.add('_upcoming');
        badge.querySelector('.sta-product-badge__name').textContent = 'Upcoming';
      }
      if (pill) pill.textContent = 'Upcoming Auction';
      if (timingTitle && startIso) {
        timingTitle.textContent = 'Starts ' + fmtDateTime(new Date(startIso));
      }
      if (timingBody && startIso) startCountdown(timingBody, startIso, 'Starting soon');
      if (priceTitle) priceTitle.textContent = aid ? 'Starting bid:' : '—';
      if (priceEl) {
        if (aid && price != null) setMoneyPrice(priceEl, price);
        else priceEl.innerHTML = '';
      }
      if (bidsEl) bidsEl.textContent = 0;
      if (cta) {
        cta.href = url;
        // Upcoming lots: always "Preview" with the blue CTA (see .sta-btn--preview).
        cta.textContent = 'Preview';
        cta.classList.add('sta-btn--preview');
      }
    }

    if (window.staApplyPriceEstimateToCard) {
      var pid = window.staProductIdFromAuctionAttrs
        ? window.staProductIdFromAuctionAttrs(a, lotFallback)
        : (lotFallback && lotFallback.productId) || '';
      window.staApplyPriceEstimateToCard(card, pid);
    }

    var wishBtn = card.querySelector('.sta-wish-btn');
    var wishProductId = window.staProductIdFromAuctionAttrs
      ? window.staProductIdFromAuctionAttrs(a, lotFallback)
      : (lotFallback && lotFallback.productId) || '';
    if (wishBtn && wishProductId) {
      wishBtn.setAttribute('data-product-id', wishProductId);
      wishBtn.setAttribute('type', 'button');
    }

    return card;
  }

  function buildCarouselSlide(row, mode, lotFallback) {
    var slide = document.createElement('div');
    slide.className = 'sta-products-carousel__product swiper-slide';
    slide.appendChild(fillLiveAuctionCard(row, mode, lotFallback));
    return slide;
  }

  function buildGridCard(row, mode, lotFallback) {
    var wrap = document.createElement('div');
    wrap.className = 'sta-collection-products__product';
    wrap.appendChild(fillLiveAuctionCard(row, mode, lotFallback));
    return wrap;
  }

  function initProductsSwiper(sliderEl, prevBtn, nextBtn) {
    if (typeof Swiper === 'undefined' || !sliderEl) return null;
    return new Swiper(sliderEl, {
      spaceBetween: 16,
      slidesPerView: 1.09,
      loop: false,
      breakpoints: {
        480: { slidesPerView: 2 },
        750: { slidesPerView: 3, spaceBetween: 24 },
        990: { slidesPerView: 4, spaceBetween: 24 },
      },
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
    });
  }

  function hydrateLiveAuctionsCarousel(sliderEl, wrapper, prevBtn, nextBtn, mode) {
    if (!wrapper) return Promise.resolve(null);
    var carouselMode = mode === 'upcoming' ? 'upcoming' : 'live';
    var emptyMessage =
      carouselMode === 'upcoming' ? 'No upcoming auctions right now.' : 'No live auctions right now.';
    wrapper.innerHTML =
      '<div class="sta-products-carousel__product swiper-slide" style="padding:12px;opacity:.6">Loading…</div>';

    var nowSec = Math.floor(Date.now() / 1000);
    var parts = partitionLots(collectShopifyAuctionLots(), nowSec);
    // Live first (soonest ending first), then lots inside their 24h hold, so the
    // carousel still leads with what can be bid on.
    var selected =
      carouselMode === 'upcoming' ? parts.upcoming : parts.live.concat(parts.ended);

    return Promise.all(selected.map(enrichLot))
      .then(function (rows) {
        wrapper.innerHTML = '';
        if (!rows.length) {
          wrapper.innerHTML =
            '<div class="sta-products-carousel__product swiper-slide" style="padding:12px;opacity:.6">' +
            emptyMessage +
            '</div>';
          return null;
        }
        rows.forEach(function (row, idx) {
          var lot = selected[idx];
          var slideMode = lot && lot.endTs <= nowSec ? 'ended' : carouselMode;
          wrapper.appendChild(buildCarouselSlide(row, slideMode, lot));
        });
        if (window.staWishlistSyncButtons) window.staWishlistSyncButtons();
        return initProductsSwiper(sliderEl, prevBtn, nextBtn);
      })
      .catch(function (err) {
        console.error('[sta-live-auction-lots] carousel hydrate failed', err);
        wrapper.innerHTML =
          '<div class="sta-products-carousel__product swiper-slide" style="padding:12px;opacity:.6">' +
          emptyMessage +
          '</div>';
        return null;
      });
  }

  window.staLiveAuctionLots = {
    collectShopifyAuctionLots: collectShopifyAuctionLots,
    partitionLots: partitionLots,
    enrichLot: enrichLot,
    fillLiveAuctionCard: fillLiveAuctionCard,
    buildCarouselSlide: buildCarouselSlide,
    buildGridCard: buildGridCard,
    initProductsSwiper: initProductsSwiper,
    hydrateLiveAuctionsCarousel: hydrateLiveAuctionsCarousel,
  };
})();
